import { createContext, useState, ReactNode, useMemo } from 'react';
import { useI18nContext } from '../i18n/i18n-react';

interface IncompleteAnswersModalInfo {
  text: string;
  title: string;
}

interface IncompleteAnswersModalInfoType {
  modalInfo: IncompleteAnswersModalInfo;
  setModalInfo: (modalInfo: IncompleteAnswersModalInfo) => void;
}

/**
 * Context for managing the incomplete answers modal state and information.
 * Provides access to the modal content and a method to update it.
 *
 * @example
 * // To use this context in a component:
 * const { modalInfo, setModalInfo } = useContext(IncompleteAnswersModalInfoContext);
 */
export const IncompleteAnswersModalInfoContext = createContext<IncompleteAnswersModalInfoType>({
  modalInfo: {
    title: 'ERROR',
    text: 'incompleteAnswersModalContext called outside of provider IncompleteAnswersModalInfoContext'
  },
  setModalInfo: () => {}
});

export const IncompleteAnswersModalContextProvider = ({ children }: { children: ReactNode }) => {
  const translate = useI18nContext().LL;

  const [modalInfo, setModalInfo] = useState<IncompleteAnswersModalInfo>({
    title: translate.quiz.modals.allAnswerBoxesNeedToBeFilled(),
    text: translate.quiz.modals.checkAllAnswerBoxesFilled()
  });

  return (
    <IncompleteAnswersModalInfoContext.Provider
      value={useMemo(() => ({ modalInfo, setModalInfo }), [modalInfo])}
    >
      {children}
    </IncompleteAnswersModalInfoContext.Provider>
  );
};
